/**
 * Vendors carousel functionality
 */

import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import axios from 'axios';

Vue.use(VueCarousel);

let vendorCarousel;

if(document.getElementById('vendors')) {
	vendorCarousel = new Vue({

		el: '#vendors',

		data() {
			return {
				/** @type {Array} valid vendor type ids */
				types: this.getTypes(),

				/** @type {String} active vendor type id */
				activeType: null,

				/** @type {Number} vendors per page */
				perPage: 16,

				/** @type {Number} current page */
				page: 1,

				/** @type {Object} raw data store */
				store: {},

				/** @type {Array} currently active vendor pages */
				activeItems: [],

				/** @type {Glide} carousel instance */
				// carousel: null,
			};
		},

		/**
		 * Computed properties
		 * @type {Object}
		 */
		computed: {
			/**
			 * Total number of currently available pages
			 * @return {Number}
			 */
			totalPages() {
				return this.activeItems.length;
			}
		},

		/**
		 * Instance created lifecycle hook
		 */
		created() {
			this.setActiveType(this.initialType());
		},


		watch: {
			activeItems(newValue, oldValue) {
				if(newValue) {
					this.$nextTick(() => {
						// if(this.carousel && newValue) this.carousel.mount();
					});
				}
			},

			activeType(newValue, oldValue) {
				this.setCarouselHeight();
			}

		},

		/**
		 * Instance methods
		 * @type {Object}
		 */
		methods: {

			/**
			 * Get the available vendor types
			 * @return {Array} vendor type ids
			 */
			getTypes() {
				const navLinks = document.querySelectorAll('#vendors-header a');
				let types = [];

				navLinks.forEach(function(link) {
					types.push(link.getAttribute('href').replace('#', ''));
				})

				return types;
			},

			/**
			 * Determine the initial vendor type
			 * @return {String} type id
			 */
			initialType() {
				let type = this.types[0];
				// needs some way to set the initial type per-page
				return type;
			},

			/**
			 * Set the active type
			 * @param {String} type type id
			 */
			setActiveType(type) {
				// do nothing if already active
				if(this.activeType == type) return;

				this.page = 1;
				this.activeItems = [];

				if(!this.store[type]) {
					this.getVendors(type);
				} else {
					this.setActiveItems(type);
				}

				this.activeType = type;
			},

			setActiveItems(type) {
				this.activeItems = this.chunk(this.store[type], this.perPage);
			},

			getVendors(type) {

				let url = '/wp-json/slowdough/vendors/';

				axios.get(url + type)
					.then(response => {
						this.store[type] = response.data.vendors;
						if(this.activeType == type) this.setActiveItems(type);
					})
					.catch(error => {
						console.error('error retrieving vendors', error);
					})

			},

			setCarouselHeight() {
				this.$nextTick(() => {
					window.setTimeout(() => {
						this.$children[0].getCarouselHeight();
					}, 250);
				})
			},

			chunk(arr, size) {
				const chunked = [];

				for(let i = 0; i < arr.length; i++) {
					const last = chunked[chunked.length - 1];

					if(!last || last.length === size) {
						chunked.push([arr[i]]);
					} else {
						last.push(arr[i]);
					}
				}

				return chunked;
			}

		}
	});
}